module.exports = __webpack_public_path__ + "media/leather_3.ec758e81.webm";